<main class="h-100">
    <router-outlet></router-outlet>
    <app-toaster-notifications  [type]="toastrData?.type" [message]="toastrData?.message" [class]="toastrData?.class"> </app-toaster-notifications>
    <app-cookie-banner></app-cookie-banner>
</main>